export class ActionItem {
  constructor(
    public actionText: string,
    public actionFunctionName: string) { }
}
